import React from "react";

const fixEncoding = (text = "") =>
  text
    // Common UTF-8→Win-1252 mojibake fixes
    .replace(/â€™/g, "'")
    .replace(/â€œ/g, '"')
    .replace(/â€/g, '"')
    .replace(/â€”/g, "—")
    .replace(/â€“/g, "–")
    .replace(/â€¦/g, "…")
    .replace(/â€˜/g, "'")
    .replace(/Â /g, " ")
    .replace(/Â/g, "");

const normalizeLine = (line = "") => line.replace(/\s+/g, " ").trim();

const stripChordsToHtml = (text = "", hiddenSet = new Set(), onHideLine) => {
  const fixed = fixEncoding(text);

  const cleaned = fixed
    .replace(/\[[^\]]+\]/g, "") // remove [C] chords
    .replace(/\{[^}]+\}/g, "") // remove directives
    .replace(/\r\n/g, "\n");

  const lines = cleaned.split("\n");

  // Remove leading empty lines to avoid spacer stack at top
  while (lines.length && !lines[0].trim()) {
    lines.shift();
  }

  const navLabelRegex = /^(verse|v|chorus|c|intro|interlude|instrumental|inst|bridge|tag|outro|ending|refrain|pre[- ]?chorus|prechorus|vamp|solo)(\s+\d+)?[:.]?$/i;
  const rendered = [];

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i].trim();
    if (navLabelRegex.test(line)) {
      continue;
    }
    const normalized = normalizeLine(line);
    if (normalized && hiddenSet.has(normalized)) {
      continue;
    }
    if (!line) {
      rendered.push(
        <div key={`spacer-${i}`} className="lyrics-line spacer"></div>,
      );
    } else {
      const compact = line.replace(/\s+/g, " ");
      rendered.push(
        <div
          key={`line-${i}-${compact}`}
          className="lyrics-line"
          title="Shift+click to hide this line"
          onClick={(e) => {
            if (e.shiftKey && onHideLine) {
              onHideLine(normalized);
            }
          }}
        >
          {compact}
        </div>,
      );
    }
  }

  return rendered;
};

const LyricsDisplay = ({ section, settings, isBlackout, contentRef, hiddenLines, onHideLine }) => {
  const lines = React.useMemo(() => {
    if (!section?.content) return [];
    try {
      return stripChordsToHtml(section.content, hiddenLines, onHideLine);
    } catch (err) {
      console.warn("Failed to render chordpro, falling back to raw lyrics:", err);
      return stripChordsToHtml(section.content, hiddenLines, onHideLine);
    }
  }, [section?.content, hiddenLines, onHideLine]);

  return (
    <div className={`lyrics-frame ${isBlackout ? "lyrics-frame--blackout" : ""}`}>
      <div
        ref={contentRef}
        className="lyrics-scroll"
        style={{
          color: settings.fontColor,
          fontSize: `${settings.fontSize}px`,
          lineHeight: settings.lineHeight,
        }}
      >
        {isBlackout ? <div className="lyrics-blackout"> </div> : <div className="lyrics-body">{lines.length ? lines : <div>No lyrics available.</div>}</div>}
      </div>
    </div>
  );
};

export default LyricsDisplay;
export { normalizeLine };
